const UtilCards = () => {
    const utilCard = [
            {title: "Weather Forecast App",
            subTitle: "Weather Forecast Application",
            text: "When looking at various APIs I was most interested in the weather resourses offered by OpenWeather.  Along with a Google API to auto-complete location information this is what I came up with",
            image: "./images/weatherApp.png",
            imageAlt: "Weather Forecast App",
            linkUrl: "https://weatherappbc2023.netlify.app/",
            linkText: "Weather App" },
            {title: "Weather Forecast App",
            subTitle: "Application Repository",
            text: "The repository for this app is available here.",
            image: "./images/Github_logo.png",
            imageAlt: "Weather App Repo",
            linkUrl: "https://github.com/DataSpot42/weatherapp",
            linkText: "Weather App Code" },
            {title: "To Do App",
            subTitle: "To Do list application",
            text: "Application to add, edit and delete from a list.  Firstly as a front-end app, here using browser local storage to save the list",
            image: "./images/todoApp.png",
            imageAlt: "To Do App",
            linkUrl: "https://todotodos.netlify.app/",
            linkText: "To Do App" },
            {title: "To Do App",
            subTitle: "To Do Front End Repo",
            text: "GitHub Repository for the Front-End version of the app.  Using local storage to store.",
            image: "./images/Github_logo.png",
            imageAlt: "To Do FE Repo",
            linkUrl: "https://github.com/DataSpot42/ReactToDo",
            linkText: "To Do FE Code"},
            {title: "To Do App",
            subTitle: "Full Stack Repo",
            text: "GitHub Repo with Full MERN Stack.  Database on MongoDB",
            image: "./images/Github_logo.png",
            imageAlt: "Full Stack Code",
            linkUrl: "https://github.com/DataSpot42/FullStackToDo",
            linkText: "To Do FS Code" },
            {title: "Drum Kit",
            subTitle: "Drum Kit App",
            text: "React version of Drum Kit Task",
            image: "./images/drumbkg.jpg",
            imageAlt: "Drum Kit",
            linkUrl: "https://camelcode-drumkit.netlify.app/",
            linkText: "Drum Kit App" },            
            
            {title: "TechDog.blog",
            subTitle: "Blogging Platform Repo",
            text: "The final Bootcamp assignment was to create a full stack app in a team of 4.  We chose a blog platform and called it TechDog. As the backend is not hosted at present take a look at our GitHub Repo",
            image: "./images/Github_logo.png",
            imageAlt: "TechDog.blog Repo",
            linkUrl: "https://github.com/DataSpot42/techDogblog",
            linkText: "TechDog Code" }
            
            
                    
        ]
return (utilCard)
}
export default UtilCards